import React, { FunctionComponent } from 'react';
import { useFormContext } from 'react-hook-form';
import { get } from 'lodash';

import PhoneInputWithCountry from 'react-phone-number-input/react-hook-form';
import 'react-phone-number-input/style.css';

import { IFormPhoneInputProps } from './types';

export const PhoneInputField: FunctionComponent<IFormPhoneInputProps> = ({
  id,
  name,
  defaultValue,
  placeholder,
  validation,
  disabled,
  label,
  defaultCountry,
  className,
}) => {
  const { control, errors } = useFormContext();

  return (
    <>
      {!!get(errors, name, false) && (
        <label htmlFor={name} style={{ color: 'red' }}>
          {`${label ? label + ' - ' : ''} ${get(errors, `${name}.message`)}`}
        </label>
      )}
      {!get(errors, name, false) && <label htmlFor={name}>{label}</label>}
      <PhoneInputWithCountry
        id={id}
        name={name}
        control={control}
        defaultValue={defaultValue || ''}
        rules={validation}
        placeholder={placeholder}
        defaultCountry={defaultCountry}
        disabled={disabled}
        className={`custom-phone-input ${className || ''}`}
      />
    </>
  );
};
